import { User } from "lucide-react";
import { Navbar } from "flowbite-react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate, Link, useLocation } from "react-router-dom";

import { useStore } from "../../store";
import { SmallText } from "../../lib/ui/components/typography/Typography";
import Dropdown from "../../lib/ui/components/dropdown/Dropdown";

function CandidateHeader() {
  const uid = useStore((state) => state.uid);
  const setLogout = useStore((state) => state.setLogout);
  const auth = getAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === "/login") return null;

  const isOnAuthPage = ["/login", "/register", "/reset-password"].includes(location.pathname);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setLogout();
      navigate("/");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <nav className="h-16">
      <Navbar fluid rounded className="bg-white text-black">
        <div className="flex items-center space-x-8">
          <Navbar.Brand>
            <img
              src="/june logo png.png"
              className="ml-12 mr-2 h-4 sm:h-4"
              alt="4amd Hiring Logo"
            />
          </Navbar.Brand>
          {!isOnAuthPage && (
            <>
              <Link
                to="/candidate/dashboard"
                className="text-gray-700 hover:text-gray-900 transition-colors"
                style={{ textDecoration: "none" }}
              >
                <SmallText weight="semibold">Dashboard</SmallText>
              </Link>

              <Link
                to="/candidate/companies"
                className="text-gray-700 hover:text-gray-900 transition-colors"
                style={{ textDecoration: "none" }}
              >
                <SmallText weight="semibold">Roles</SmallText>
              </Link>

              <Link
                to="/candidate/profile"
                className="text-gray-700 hover:text-gray-900 transition-colors"
                style={{ textDecoration: "none" }}
              >
                <SmallText weight="semibold">Candidate Profile</SmallText>
              </Link>
            </>
          )}
        </div>
        <div className="flex md:order-2 text-dark items-center space-x-4">
          {uid ? (
            <Dropdown
              placement="bottom-end"
              trigger={
                <button
                  className="p-2 rounded-md hover:bg-gray-100 transition-colors"
                  aria-label="User menu"
                >
                  <User size={20} className="text-gray-700" />
                </button>
              }
              items={[
                {
                  label: "Account",
                  onClick: () => navigate("/candidate/account"),
                },
                {
                  label: "Preferences",
                  onClick: () => navigate("/candidate/preferences"),
                },
                {
                  label: "Sign Out",
                  onClick: handleSignOut,
                  variant: "danger",
                },
              ]}
            />
          ) : (
            <Link to="/login">
              <button className="border-2 border-blue-500 text-blue-500 bg-transparent hover:bg-blue-500 hover:text-white text-label transition-all duration-300 ease-in-out px-4 py-2 rounded">
                Log in
              </button>
            </Link>
          )}
        </div>
      </Navbar>
    </nav>
  );
}

export default CandidateHeader;
